import { Grid, Box, Typography, Chip, LinearProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { pipelineDataTemplate } from '../../../services/apiDataTemplate';
import secureLocalStorage from 'react-secure-storage';

const PipelineData = (props) => {

  //#region props
  const { pipelineData } = props;

  //#region variables
  const pipelineFields = {
    dealInformation: [
      { label: "Deal Source:", value: "Direct Outreach", apiFieldName: "deal_Source" },
      { label: "Contact Date:", value: "2024-05-15", apiFieldName: "contact_Date" },
      { label: "Sector:", value: "AI/ML", apiFieldName: "sector" },
      { label: "Geography:", value: "North America", apiFieldName: "geography" },
      { label: "Risk Rating:", value: <Chip
        label="Medium (6.5/10)"
        sx={{
          background: '#FFF3CD',
          color: '#856404',
          fontWeight: 500,
          fontSize: 13,
          height: 24,
          borderRadius: 1,
          mt: 0.5
        }}
        size="small"
      />, apiFieldName: "risk_Rating" }
    ],
    dealProgress: [
      { label: "Current Stage:", value: "Series A", apiFieldName: "current_Stage" },
      { label: "Expected Close:", value: "Q3 2024", apiFieldName: "expected_Close" },
      { label: "Probability:", value: <Chip
        label="70%"
        sx={{
          background: '#1976d2',
          color: '#fff',
          fontWeight: 700,
          fontSize: 13,
          height: 24,
          borderRadius: 1,
          mt: 0.5
        }}
        size="small"
      />, apiFieldName: "probability" },
      { label: "Lead Investor:", value: "Sequoia Capital", apiFieldName: "lead_Investor" },
      { label: "Amount:", value: <span style={{ color: '#1976d2', fontWeight: 700 }}>$5M</span>, apiFieldName: "amount" }
    ],
    keyMetrics: [
      { label: "ARR:", value: <span style={{ color: '#1976d2', fontWeight: 700 }}>$2M</span>, apiFieldName: "arr" },
      { label: "Growth Rate:", value: <span style={{ color: 'green', fontWeight: 700 }}>150%</span>, apiFieldName: "growth_Rate" },
      { label: "Customers:", value: <span style={{ color: 'green', fontWeight: 700 }}>500+</span>, apiFieldName: "customers" },
      { label: "Churn Rate:", value: <span style={{ fontWeight: 700 }}>5%</span>, apiFieldName: "churn_Rate" },
     /*  { label: "NPS Score:", value: <span style={{ color: 'green', fontWeight: 700 }}>67</span>, apiFieldName: "npS_Score" } */
    ]
  };

  //#region styles
  const borderLine = {
    border: '1px solid #ccc',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    background: '#fff'
  }

  //#region render functions
  const renderSection = (title, data, information) => (
    <div style={borderLine}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>{title}</Typography>
      <Grid container spacing={1}>
        {data.map((item, idx) => {
          let value = information[item.apiFieldName];

          // Compare with label instead of apiFieldName
          if (item.label === "Risk Rating:" && value) {
            value = (
              <Chip
                label={value}
                sx={{
                  background: '#FFF3CD',
                  color: '#856404',
                  fontWeight: 500,
                  fontSize: 13,
                  height: 24,
                  borderRadius: 1,
                  mt: 0.5
                }}
                size="small"
              />
            );
          } else if (item.label === "Probability:" && value) {
            value = (
              <Chip
                label={value}
                sx={{
                  background: '#1976d2',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 13,
                  height: 24,
                  borderRadius: 1,
                  mt: 0.5
                }}
                size="small"
              />
            );
          } else if (item.label === "Amount:" && value) {
            value = <span style={{ color: '#1976d2', fontWeight: 700 }}>{value}</span>;
          }  else if (item.label === "Growth Rate:" && value) {
            value = <span style={{ color: 'green', fontWeight: 700 }}>{value}</span>;
          }  else if (item.label === "NPS Score:" && value) {
            value = <span style={{ color: 'green', fontWeight: 700 }}>{value}</span>;
          }  else if (!value) {
            value = <span style={{ color: '#bbb' }}>NA</span>;
          }

          return (
            <div className='space-between' key={idx} style={{ width: '100%' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>{item.label}</Typography>
              <Typography variant="body1" sx={{ color: '#333' }}>
                {value}
              </Typography>
            </div>
          );
        })}
      </Grid>
    </div>
  );

  //#region return
  return (
    <div style={{ ...borderLine, margin: 0 }} className='child-margin-15'>
      {
        pipelineData
        ? (
            <>
              {renderSection("Deal Information", pipelineFields.dealInformation,pipelineData.deal_Information)}
              {renderSection("Deal Progress", pipelineFields.dealProgress, pipelineData.deal_Progress)}
              {renderSection("Key Metrics", pipelineFields.keyMetrics, pipelineData.key_Metrics)}
            </>
          )
        : <LinearProgress />
      }
    </div>
  )
}

export default PipelineData